import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Devocional from "@/pages/Devocional";
import DevocionalArchive from "@/pages/DevocionalArchive";
import SermonDetail from "@/pages/SermonDetail";
import BookDetail from "@/pages/BookDetail";
import LivrosIndex from "@/pages/LivrosIndex";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SeriesIndex from "@/pages/SeriesIndex";
import SeriesDetail from "@/pages/SeriesDetail";
import PlansIndex from "@/pages/PlansIndex";
import PlanDetail from "@/pages/PlanDetail";
import AuthCallback from "@/pages/AuthCallback";
import CategoryPage from "@/pages/CategoryPage";
import SemanaDeOracao from "@/pages/SemanaDeOracao";
import Semana from "@/pages/Semana";
import Sobre from "@/pages/Sobre";
import InstitutoPage from "@/pages/InstitutoPage";
import VideosPage from "@/pages/VideosPage";
import ProtectedRoute from "@/components/ProtectedRoute";

function AuthHashGate({ children }) {
  // CRITICAL: detect session_id during render to avoid race conditions.
  // If user landed on any URL with #session_id=... we send them to /auth/callback
  // (where AuthCallback handles the exchange) before any other route runs.
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    const hash = window.location.hash;
    // Replace history so back button doesn't bring user back to a fragment they don't own
    window.history.replaceState(null, "", "/auth/callback" + hash);
    return <AuthCallback />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthHashGate>
        <Routes>
          <Route path="/" element={<Sobre isHome={true} />} />
          <Route path="/palavra-de-hoje" element={<Home />} />
          <Route path="/hoje" element={<Home />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/devocional" element={<Devocional />} />
          <Route path="/devocional/hoje" element={<Devocional />} />
          <Route path="/devocional/arquivo" element={<DevocionalArchive />} />
          <Route path="/devocional/:id" element={<Devocional />} />
          <Route path="/semana" element={<Semana />} />
          <Route path="/pregacoes/:id" element={<SermonDetail />} />
          <Route path="/livros" element={<LivrosIndex />} />
          <Route path="/livros/:slug" element={<BookDetail />} />
          <Route path="/series" element={<SeriesIndex />} />
          <Route path="/series/:categorySlug/:seriesSlug" element={<SeriesDetail />} />
          <Route path="/planos" element={<PlansIndex />} />
          <Route path="/planos/:slug" element={<PlanDetail />} />
          <Route path="/semana-de-oracao" element={<SemanaDeOracao />} />
          {/* SEO category pages (Sprint B item 1) */}
          <Route path="/sermoes" element={<CategoryPage />} />
          <Route path="/devocionais" element={<CategoryPage />} />
          <Route path="/familia" element={<CategoryPage />} />
          <Route path="/lideranca" element={<CategoryPage />} />
          <Route path="/casamento" element={<CategoryPage />} />
          <Route path="/pentecostes" element={<CategoryPage />} />
          <Route path="/discipulado" element={<CategoryPage />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/instituto" element={<InstitutoPage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        </AuthHashGate>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
